import { NICmsContentComponent } from '@icms/core/content';
import { ICmsComponentCwvConfig } from '../../../catalog/config/component.config';

export namespace NCmsComponentImage {
    export const ID = 'image';

    export interface IData extends NICmsContentComponent.IData, ICmsComponentCwvConfig {
        image: string;
        ratio: string;
        cta_link?: string;
    }
}
